// Function to generate brand and occasion QL on PDP
export const generateBrandOccasionQL = (categoryLinks, vendorShortName, occasionNames, vendorName) => {
    // Build the URL for the occasion filter with necessary query parameters
    let brandOccasionLinks = [];

    // Check if the brand link already exists in the categoryLinks array
    const brandExists = categoryLinks.some(link => link?.text === vendorName);
    if (!brandExists) {
        const brandLink = {
            link: `${process.env.NETLIFY_URL}/designer/${vendorShortName}`,
            text: vendorName
        };
        brandOccasionLinks.push(brandLink);
    }

    // Iterate through the occasionNames array and add each occasion to the links
    if (occasionNames && occasionNames.length > 0) {
        occasionNames.forEach(occasionName => {
            const buildOccasionURL = `products%5BrefinementList%5D%5Bnamed_tags.categories.lvl0%5D%5B0%5D=${encodeURIComponent(categoryLinks[0]?.text.trim())}&products%5BrefinementList%5D%5Bnamed_tags.Occasion%5D%5B0%5D=${encodeURIComponent(occasionName)}`;

            // Check if the occasion link already exists in the categoryLinks array
            const occasionExists = categoryLinks.some(link => link?.text === occasionName);
            if (!occasionExists) {
                const occasionLink = {
                    link: `${categoryLinks[0]?.link}?${buildOccasionURL}`,
                    text: occasionName
                };
                brandOccasionLinks.push(occasionLink);
            }
        });
    }

    // Return the updated categoryLinks array
    return brandOccasionLinks;
};